export default __webpack_public_path__ + "static/media/img4.34e4aaf5.JPG";